import $ from 'jquery';
import Player from '@vimeo/player'

// Video Grid Iframes
var iframes = $('.js--vimeo iframe');
$.each(iframes, function(key, value) {
	if( iframes[key].src.indexOf( 'vimeo' ) !== -1 ) {
		var player = new Player(iframes[key]);
		$('body').on('click', function() {
			player.getPaused().then(function(paused) {
			    if(!paused) {
			    	player.pause();
			    }
			})
		})
	}
});

// Single Video
var singleVideo = $('.js--single iframe');
var singleVideoOverlay = $('.js--single-video-overlay');
$('.js--single-video-play').on('click', function() {
	singleVideo.css( { "opacity": "1", "z-index": 1 } );
	singleVideoOverlay.hide();
	var player = new Player(singleVideo[0]);
	player.play();
});
